import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.334 12a.667.667 0 0 0 .667-.666V3.607l1.526 1.534a.67.67 0 1 0 .947-.947L9.807 1.527a.67.67 0 0 0-.726-.14.67.67 0 0 0-.414.614v9.333a.667.667 0 0 0 .667.667M6.92 14.615A.67.67 0 0 0 7.334 14V4.668a.667.667 0 0 0-1.333 0v7.727L4.474 10.86a.669.669 0 1 0-.947.946l2.667 2.667a.67.67 0 0 0 .727.14"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })